import type { IMarketplace } from './types';

// const marketplaces: IMarketplace[] = [
//   { label: 'All', value: 'All', type: 'All' },
//
//   { label: 'Amazon', value: 'Amazon', type: 'Amazon' },
//   { label: 'Walmart', value: 'Walmart', type: 'Walmart' },
// ];

export const marketplaceGroups: IMarketplace[] = [
  { label: 'All Marketplaces', value: 'All', type: 'All' },
  { label: 'Amazon', value: 'Amazon', type: 'Amazon' },
  { label: 'Walmart', value: 'Walmart', type: 'Walmart' },
  { label: 'TikTok', value: 'TikTok', type: 'TikTok' },
  {
    label: 'Amazon NA',
    value: 'Amazon NA',
    options: [
      { label: 'USA', value: 'ATVPDKIKX0DER', type: 'Amazon', flag: '🇺🇸' },
      { label: 'Canada', value: 'A2EUQ1WTGCTBG2', type: 'Amazon', flag: '🇨🇦' },
      { label: 'Mexico', value: 'A1AM78C64UM0Y8', type: 'Amazon', flag: '🇲🇽' },
      { label: 'Brazil', value: 'A2Q3Y263D00KWC', type: 'Amazon', flag: '🇧🇷' },
    ],
  },
  {
    label: 'Amazon EU',
    value: 'Amazon EU',
    options: [
      { label: 'UK', value: 'A1F83G8C2ARO7P', type: 'Amazon', flag: '🇬🇧' },
      { label: 'Germany', value: 'A1PA6795UKMFR9', type: 'Amazon', flag: '🇩🇪' },
      { label: 'France', value: 'A13V1IB3VIYZZH', type: 'Amazon', flag: '🇫🇷' },
      { label: 'Spain', value: 'A1RKKUPIHCS9HS', type: 'Amazon', flag: '🇪🇸' },
      { label: 'Italy', value: 'APJ6JRA9NG5V4', type: 'Amazon', flag: '🇮🇹' },
      { label: 'Netherlands', value: 'A1805IZSGTT6HS', type: 'Amazon', flag: '🇳🇱' },
      { label: 'Sweden', value: 'A2NODRKZP88ZB9', type: 'Amazon', flag: '🇸🇪' },
      { label: 'Poland', value: 'A1C3SOZRARQ6R3', type: 'Amazon', flag: '🇵🇱' },
      { label: 'Belgium', value: 'AMEN7PMS3EDWL', type: 'Amazon', flag: '🇧🇪' },
      // { label: 'India', value: 'A21TJRUUN4KGV', type: 'Amazon', flag: '🇮🇳' },
      // { label: 'South Africa', value: 'AE08WJ6YKNBMC', type: 'Amazon', flag: '🇿🇦' }, // Not Yet
      // { label: 'United Arab Emirates (U.A.E.)', value: 'A2VIGQ35RCS4UG', type: 'Amazon', flag: '🇦🇪' }, // Not Yet
      // { label: 'Egypt', value: 'ARBP9OOSHTCHU', type: 'Amazon', flag: '🇪🇬' }, // Not Yet
      // { label: 'Saudi Arabia', value: 'A17E79C6D8DWNP', type: 'Amazon', flag: '🇸🇦' },
      // { label: 'Turkey', value: 'A33AVAJ2PDY3EV', type: 'Amazon', flag: '🇹🇷' },
    ],
  },
  {
    label: 'Amazon FE',
    value: 'Amazon FE',
    options: [
      { label: 'Japan', value: 'A1VC38T7YXB528', type: 'Amazon', flag: '🇯🇵' },
      { label: 'Australia', value: 'A39IBJ37TRP1C6', type: 'Amazon', flag: '🇦🇺' },
      { label: 'Singapore', value: 'A19VAU5U5O7RUS', type: 'Amazon', flag: '🇸🇬' },
    ],
  },
];

export const marketplaceGroupsAmazon: IMarketplace[] = [
  { label: 'All Marketplaces', value: 'All', type: 'All' },
  {
    label: 'Amazon NA',
    value: 'Amazon NA',
    options: [
      { label: 'USA', value: 'ATVPDKIKX0DER', type: 'Amazon', flag: '🇺🇸' },
      { label: 'Canada', value: 'A2EUQ1WTGCTBG2', type: 'Amazon', flag: '🇨🇦' },
      { label: 'Mexico', value: 'A1AM78C64UM0Y8', type: 'Amazon', flag: '🇲🇽' },
      { label: 'Brazil', value: 'A2Q3Y263D00KWC', type: 'Amazon', flag: '🇧🇷' },
    ],
  },
  {
    label: 'Amazon EU',
    value: 'Amazon EU',
    options: [
      { label: 'UK', value: 'A1F83G8C2ARO7P', type: 'Amazon', flag: '🇬🇧' },
      { label: 'Germany', value: 'A1PA6795UKMFR9', type: 'Amazon', flag: '🇩🇪' },
      { label: 'France', value: 'A13V1IB3VIYZZH', type: 'Amazon', flag: '🇫🇷' },
      { label: 'Spain', value: 'A1RKKUPIHCS9HS', type: 'Amazon', flag: '🇪🇸' },
      { label: 'Italy', value: 'APJ6JRA9NG5V4', type: 'Amazon', flag: '🇮🇹' },
      { label: 'Netherlands', value: 'A1805IZSGTT6HS', type: 'Amazon', flag: '🇳🇱' },
      { label: 'Sweden', value: 'A2NODRKZP88ZB9', type: 'Amazon', flag: '🇸🇪' },
      { label: 'Poland', value: 'A1C3SOZRARQ6R3', type: 'Amazon', flag: '🇵🇱' },
      { label: 'Belgium', value: 'AMEN7PMS3EDWL', type: 'Amazon', flag: '🇧🇪' },
      // { label: 'India', value: 'A21TJRUUN4KGV', type: 'Amazon', flag: '🇮🇳' },
      // { label: 'South Africa', value: 'AE08WJ6YKNBMC', type: 'Amazon', flag: '🇿🇦' }, // Not Yet
      // { label: 'United Arab Emirates (U.A.E.)', value: 'A2VIGQ35RCS4UG', type: 'Amazon', flag: '🇦🇪' }, // Not Yet
      // { label: 'Egypt', value: 'ARBP9OOSHTCHU', type: 'Amazon', flag: '🇪🇬' }, // Not Yet
      // { label: 'Saudi Arabia', value: 'A17E79C6D8DWNP', type: 'Amazon', flag: '🇸🇦' },
      // { label: 'Turkey', value: 'A33AVAJ2PDY3EV', type: 'Amazon', flag: '🇹🇷' },
    ],
  },
  {
    label: 'Amazon FE',
    value: 'Amazon FE',
    options: [
      { label: 'Japan', value: 'A1VC38T7YXB528', type: 'Amazon', flag: '🇯🇵' },
      { label: 'Australia', value: 'A39IBJ37TRP1C6', type: 'Amazon', flag: '🇦🇺' },
      { label: 'Singapore', value: 'A19VAU5U5O7RUS', type: 'Amazon', flag: '🇸🇬' },
    ],
  },
];
